import DefaultOptionsMenu, {
  type DefaultOptionsMenuProps,
} from '@/components/DefaultOptionsMenu';
import { MenuItem } from '@/components/Menu';
import { DownloadIcon, MoveFileIcon, ShareIcon, ShowIcon } from '@/icons';

export interface ContentMenuProps extends Omit<
  DefaultOptionsMenuProps,
  'extraOptions'
> {
  onDownload?: () => void;
  onShare?: () => void;
  onMove?: () => void;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export default function ContentMenu({
  onDownload,
  onShare,
  onMove,
  onView,
  ...props
}: ContentMenuProps) {
  const handleClick = (cb: () => void) => {
    return () => {
      cb();
      props.onClose();
    };
  };

  return (
    <DefaultOptionsMenu
      extraOptions={[
        onDownload && (
          <MenuItem
            key="download"
            label="Download"
            icon={<DownloadIcon />}
            onClick={handleClick(onDownload)}
          />
        ),
        onShare && (
          <MenuItem
            key="share"
            label="Share"
            icon={<ShareIcon />}
            onClick={handleClick(onShare)}
          />
        ),
        onMove && (
          <MenuItem
            key="move"
            label="Move"
            icon={<MoveFileIcon />}
            onClick={handleClick(onMove)}
          />
        ),
        <MenuItem
          key="view"
          label="View"
          icon={<ShowIcon />}
          onClick={handleClick(onView)}
        />,
      ]}
      {...props}
    />
  );
}
